
import React, { useEffect, useRef, useState } from "react";
import "./banner.scss";
import { Dropdown } from "react-bootstrap";
import axios from "axios";
import { api_url } from "../../../utils/Enviroment";
import useWeb3 from "../../../hooks/useWeb3";
import CustomPagination from "../../CustomPagination";
import { formatNumbers, getPoolsStatus, renderOptions, convertFromWei, getTokenSymbol, formatSmartDecimal, convertFromWeiEthers, formatNumberWithCommas, getMarketToken, isStableTokenSymbol } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { getMarkets, getSearchedMarkets, getTotalPoolsParticipants, tokenToDollarConvertion } from "../../../utils/services";
import { ALL_MARKETS, LIGHT_THEME, LIVE, marketFilterOptions, SEARCH_MARKETS_DEBOUNCE, TOKEN_RAIN } from "../../../utils/constants";
import { useTheme } from "../../../contexts/ThemeProvider";
import PoolTimerUI from "../../DetailPage/PoolTimerUI";
import MarketCarousel from "./MarketCarousel";
import { MARKET_STATUS, MARKET_STATUS_BACKGROUNDS, MARKET_STATUS_TEXT_COLORS } from "../../../utils/MarketStatus";
import { Link } from "react-router-dom";
import useSocket from "../../SocketIo";
import { detailPath } from "../../../constants/Routes";

const Banner = () => {
  const { t } = useTranslation();
  const [key, setKey] = useState('All');
  const [keyPriv, setKeyPriv] = useState('All');
  const [pools, setPools] = useState([]);
  const [poolsprivate, setPoolsPrivate] = useState([]);
  const [tvlPlatform, setTvlPlatform] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const web3 = useWeb3()
  const [volumn, setVolumn] = useState([]);
  const [losers, setLosers] = useState([]);
  const [gainers, setGainers] = useState([]);
  const [selectedtimeframewinners, setSelectedTimeframeWinners] = useState(null)
  const [selectedtimeframelosers, setSelectedTimeframeLosers] = useState(null)
  const [totalParticipants, setTotalParticipants] = useState("");
  const [totalMarkets, setTotalMarkets] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(3);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [totalPages2, setTotalPages2] = useState(3);
  const [activeTab, setActiveTab] = useState("public");
  const [pollStatus, setPollStatus] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loadingSearchedData, setLoadingSearchedData] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const inputRef = useRef(null);

  const handleKeyDown = (e) => {
    e.stopPropagation(); // stop bootstrap
    if (!searchResults.length) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndex((prev) =>
          prev < searchResults.length - 1 ? prev + 1 : 0
        );
        break;

      case "ArrowUp":
        e.preventDefault();
        setActiveIndex((prev) =>
          prev > 0 ? prev - 1 : searchResults.length - 1
        );
        break;

      case "Enter":
        if (activeIndex >= 0) {
          window.location.href = detailPath(searchResults[activeIndex]._id);
        }
        break;

      case "Escape":
        setActiveIndex(-1);
        break;

      default:
        break;
    }
  };

  const { theme } = useTheme()
  const [isMarketFilterOpen, setMarketFilterOpen] = useState(false);
  const [selectedMarketFilter, setSelectedMarketFilter] = useState(LIVE);
  const [tokenPriceToUsdt, setTokenPriceToUsd] = useState()

  const toggleMarketFilter = (isOpen) => setMarketFilterOpen(isOpen);
  const handleMarketFilterSelect = async (filter) => {
    setSelectedMarketFilter(filter);
    setMarketFilterOpen(false);
  };

  const [sortKeys, setSortKeys] = useState({
    public: "By Volume",
    private: "By Volume",
  });

  const tabProperties = [
    { eventKey: 'All', title: t('All') },
    { eventKey: 'AltCoins', title: t('Altcoin ★') },
    { eventKey: 'CRYPTO', title: t('Crypto') },
    { eventKey: 'POLITICS', title: t('Politics') },
    { eventKey: 'FINANCE', title: t('Finance') },
    { eventKey: 'SPORTS', title: t('Sports') },
    { eventKey: 'TECHNOLOGY', title: t('Technology') },
    { eventKey: 'ENTERTAINMENT', title: t('Entertainment') },
    { eventKey: 'SCIENCE', title: t('Science') },
    { eventKey: 'BUSINESS', title: t('Business') },
    { eventKey: 'WEATHER', title: t('Weather') },
    { eventKey: 'CULTURE', title: t('Culture') },
    { eventKey: 'GAMING', title: t('Gaming') },
    { eventKey: 'LEGAL', title: t('Legal') },
    { eventKey: 'MILITARY', title: t('Military') },
    { eventKey: 'SPACE', title: t('Space') },
    { eventKey: 'HEALTH', title: t('Health') },
    { eventKey: 'EDUCATION', title: t('Education') },
    { eventKey: 'ART', title: t('Art') },
    { eventKey: 'OTHER', title: t('Other') },
  ];
  const tabPropertiesPriv = [
    { eventKey: 'All', title: t('All') },
    { eventKey: 'CRYPTO', title: t('Crypto') },
    { eventKey: 'POLITICS', title: t('Politics') },
    { eventKey: 'FINANCE', title: t('Finance') },
    { eventKey: 'SPORTS', title: t('Sports') },
    { eventKey: 'TECHNOLOGY', title: t('Technology') },
    { eventKey: 'ENTERTAINMENT', title: t('Entertainment') },
    { eventKey: 'SCIENCE', title: t('Science') },
    { eventKey: 'BUSINESS', title: t('Business') },
    { eventKey: 'WEATHER', title: t('Weather') },
    { eventKey: 'CULTURE', title: t('Culture') },
    { eventKey: 'GAMING', title: t('Gaming') },
    { eventKey: 'LEGAL', title: t('Legal') },
    { eventKey: 'MILITARY', title: t('Military') },
    { eventKey: 'SPACE', title: t('Space') },
    { eventKey: 'HEALTH', title: t('Health') },
    { eventKey: 'EDUCATION', title: t('Education') },
    { eventKey: 'ART', title: t('Art') },
    { eventKey: 'OTHER', title: t('Other') },
  ];

  const toggleDropdown = (isOpen) => {
    setIsOpen(isOpen);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageChange2 = (page) => {
    setCurrentPage2(page);
  };

  const handleTimeframeChangeGainers = (timeframe) => {
    setSelectedTimeframeWinners(timeframe);
    getTopGainers(timeframe);
  };

  const handleTimeframeChangeLosers = (timeframe) => {
    setSelectedTimeframeLosers(timeframe);
    getTopLosers(timeframe);
  };

  const getTopGainers = async (selectedtimeframewinners) => {
    try {
      const params = {};
      if (selectedtimeframewinners) {
        params.timeFilter = selectedtimeframewinners;
      }
      const response = await axios.get(`${api_url}/investments/top-winners-losers`, {
        headers: {
          "Content-Type": "application/json",
        },
        params: params
      });
      const res = response.data.data;
      setGainers(res?.winners)
    } catch (error) {
      console.error("Error fetching volume data:", error);
      console.log("Full error:", error.response || error);
    }
  };

  const getTopLosers = async (selectedtimeframelosers) => {
    try {
      const params = {};
      if (selectedtimeframelosers) {
        params.timeFilter = selectedtimeframelosers;
      }
      const response = await axios.get(`${api_url}/investments/top-winners-losers`, {
        headers: {
          "Content-Type": "application/json",
        },
        params: params
      });
      const res = response.data.data;
      setLosers(res?.losers)
    } catch (error) {
      console.error("Error fetching volume data:", error);
      console.log("Full error:", error.response || error);
    }
  };

  const getPlatformTVl = async (offset = 1) => {
    try {
      const params = {
        offset,
        limit: 10
      };
      if (key !== 'All') {
        params.tag = key;
      }

      const response = await axios.get(`${api_url}/investments/platform-tvl`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: params
      });
      let res = response.data.data?.tvl
      const tvlplatfform = convertFromWei(res, 'ether');

      setTvlPlatform(tvlplatfform);

    } catch (error) {
      console.error("Error fetching pools:", error);
    }
  };

  const sortKeyMap = {
    "Latest": "age",
    "By Liquidity": "totalLiquidity",
    "By Volume": "totalVolume"
  };

  const sortKeyMapPriv = {
    "Latest": "age",
    "By Liquidity": "totalLiquidity",
    "By Volume": "totalVolume"
  };

  const getPoolsPrivate = async (offset = 1, status) => {
    setIsTableLoading(true);
    try {
      const params = {
        offset,
        limit: 12,
        sortBy: sortKeyMapPriv[sortKeys.private] || "totalVolume",
      };
      if (status) params.status = status;

      if (keyPriv !== "All") {
        params.tag = keyPriv;
      }

      const response = await axios.get(`${api_url}/pools/pools-private`, {
        headers: { "Content-Type": "multipart/form-data" },
        params
      });

      const filteredResult = key === "All" ? response.data.data.pools.filter((markets) => markets?.token.tokenSymbol !== TOKEN_RAIN) : response.data.data.pools
      setPoolsPrivate(filteredResult);
      setTotalPages2(response?.data?.data?.pages);
    } catch (error) {
      console.error("Error fetching pools:", error);
    } finally {
      setIsTableLoading(false);
    }
  };

  const getPools = async (offset = 1, status) => {
    setIsTableLoading(true);
    try {
      const params = {
        offset,
        limit: 12,
        sortBy: sortKeyMap[sortKeys?.public] || "totalVolume",
      };
      if (status) params.status = status;

      if (key !== "All") {
        params.tag = key;
      }

      const response = await axios.get(`${api_url}/pools/public-pools`, {
        headers: { "Content-Type": "multipart/form-data" },
        params
      });
      const filteredResult = key === "All" ? response.data.data.pools.filter((markets) => markets?.token.tokenSymbol !== TOKEN_RAIN) : response.data.data.pools
      setPools(filteredResult);
      setTotalPages(response?.data?.data?.pages);
    } catch (error) {
      console.error("Error fetching pools:", error);
    }
    finally {
      setIsTableLoading(false);
    }
  };

  useEffect(() => {
    const status = getPoolsStatus(selectedMarketFilter || ALL_MARKETS);
    if (activeTab === "private") {
      setPoolsPrivate([])
      getPoolsPrivate(currentPage2, status)
    }
  }, [currentPage2, keyPriv, sortKeys?.private, activeTab, selectedMarketFilter]);

  useEffect(() => {
    const status = getPoolsStatus(selectedMarketFilter || ALL_MARKETS);
    if (activeTab === "public") {
      setPools([])
      getPools(currentPage, status);
    }
  }, [currentPage, key, sortKeys?.public, activeTab, selectedMarketFilter]);

  const handleSelectSorting = (item) => {
    setSortKeys((prev) => ({
      ...prev,
      [activeTab]: item,
    }));
  };

  const getTotalVolumn = async () => {
    try {
      const response = await axios.get(`${api_url}/investments/platform-volume`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const vol = response.data.data.totalVolume
      const VolfromWei = convertFromWei(vol?.toString())
      setVolumn(VolfromWei)
    } catch (error) {
      console.error("Error fetching pools:", error);
    }
  };

  const getTokenToDollarPrice = async () => {
    try {
      const tokenPriceRes = await tokenToDollarConvertion(TOKEN_RAIN)
      setTokenPriceToUsd(tokenPriceRes)
    } catch (error) {
      console.log('error in fetching token price: ', error);
    }
  }

  useEffect(() => {
    const getBannerApisRes = async () => {
      const totalParticipantspoolRes = await getTotalPoolsParticipants()
      const totalMarketsRes = await getMarkets()
      setTotalParticipants(totalParticipantspoolRes)
      setTotalMarkets(totalMarketsRes)
      await getTotalVolumn()
      await getPlatformTVl()
      await getTopLosers(null)
      await getTopGainers(null)
      await getTokenToDollarPrice()
    }
    getBannerApisRes()
  }, [])

  useEffect(() => {
    setLoadingSearchedData(true);
    const delayDebounce = setTimeout(async () => {
      if (searchText?.trim().length > 0) {
        try {
          const data = await getSearchedMarkets(searchText);
          setSearchResults(data);
        } catch (error) {
          setSearchResults([]);
        } finally {
          setLoadingSearchedData(false);
        }
      } else {
        setSearchResults([]);
        setLoadingSearchedData(false);
      }
    }, SEARCH_MARKETS_DEBOUNCE);
    return () => clearTimeout(delayDebounce);
  }, [searchText]);

  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(true);
  const scrollRef = useRef(null);

  const updateScrollButtons = () => {
    const container = scrollRef.current;
    if (!container) return;

    const { scrollLeft, scrollWidth, clientWidth } = container;

    setShowPrev(scrollLeft > 0);
    setShowNext(scrollLeft + clientWidth < scrollWidth - 1);
  };


  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    updateScrollButtons();
    container.addEventListener("scroll", updateScrollButtons);

    return () => container.removeEventListener("scroll", updateScrollButtons);
  }, []);


  const handlePrev = () => {
    if (scrollRef.current) {
      const container = scrollRef.current;
      const newScrollLeft = Math.max(
        container.scrollLeft - container.clientWidth,
        0
      );

      container.scrollTo({ left: newScrollLeft, behavior: "smooth" });
    }
  };




  const handleNext = () => {
    if (scrollRef.current) {
      const container = scrollRef.current;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      const newScrollLeft = Math.min(container.scrollLeft + container.clientWidth, maxScrollLeft);

      container.scrollTo({ left: newScrollLeft, behavior: "smooth" });
    }
  };


  const [enablesetting, setEnableSetting] = useState(false);

  return (
    <>
      <section className="main-banner">
        <div className="custom-container">
          <MarketCarousel tokenPrice={tokenPriceToUsdt} />
          <div className="newparent-tabs">
            <div className="new-options-parent">
              <div className="left-options">
                {activeTab === "public" && (
                  <div className="option-field">
                    <div className="inputdropdown">
                      <Dropdown
                        show={searchText.length > 0}
                        autoClose="outside"
                      >
                        <Dropdown.Toggle as="div" id="dropdown-basic">
                          <input
                            ref={inputRef}
                            type="text"
                            placeholder={t("Search Markets by keywords")}
                            value={searchText}
                            onChange={(e) => {
                              setSearchText(e.target.value);
                              setActiveIndex(-1);
                            }}
                            onKeyDown={handleKeyDown}
                          />
                        </Dropdown.Toggle>

                        {searchText.length > 0 && (
                          <Dropdown.Menu data-bs-keyboard="false">
                            {loadingSearchedData ? (
                              <Dropdown.Item disabled tabIndex={-1}>
                                <span>Loading...</span>
                              </Dropdown.Item>
                            ) : searchResults.length > 0 ? (
                              searchResults.map((item, index) => (
                                <Dropdown.Item
                                  key={item._id}
                                  href={detailPath(item._id)}
                                  active={index === activeIndex}
                                  tabIndex={-1}
                                  onMouseEnter={() => {
                                    setActiveIndex(index);
                                    inputRef.current?.focus();
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    background:
                                      index === activeIndex ? "var(--hover-bg)" : "transparent"
                                  }}
                                >
                                  <span>{item.question}</span>
                                  <span
                                    className="status"
                                    style={{
                                      backgroundColor:
                                        MARKET_STATUS_BACKGROUNDS[item.status],
                                      color:
                                        MARKET_STATUS_TEXT_COLORS[item.status],
                                    }}
                                  >
                                    {t(MARKET_STATUS[item.status])}
                                  </span>
                                </Dropdown.Item>
                              ))
                            ) : (
                              <Dropdown.Item disabled tabIndex={-1}>
                                <span>No results found</span>
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        )}
                      </Dropdown>
                    </div>

                    {searchText.length > 0 ? (
                      <svg className="search-icon" onClick={() => setSearchText("")} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M13.5 4.5L4.5 13.5" stroke="#DAD9D9" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.5 4.5L13.5 13.5" stroke="#DAD9D9" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    ) : (
                      <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M15.1479 14.3519L11.6274 10.8321C12.6478 9.60705 13.1566 8.03577 13.048 6.44512C12.9394 4.85447 12.2218 3.36692 11.0443 2.29193C9.8669 1.21693 8.32035 0.637251 6.72641 0.673476C5.13247 0.709701 3.61386 1.35904 2.48648 2.48642C1.3591 3.6138 0.709762 5.13241 0.673537 6.72635C0.637312 8.32029 1.21699 9.86684 2.29199 11.0443C3.36699 12.2217 4.85453 12.9394 6.44518 13.048C8.03583 13.1566 9.60711 12.6477 10.8322 11.6273L14.352 15.1479C14.4043 15.2001 14.4663 15.2416 14.5346 15.2699C14.6029 15.2982 14.6761 15.3127 14.75 15.3127C14.8239 15.3127 14.8971 15.2982 14.9654 15.2699C15.0336 15.2416 15.0957 15.2001 15.1479 15.1479C15.2002 15.0956 15.2417 15.0336 15.2699 14.9653C15.2982 14.897 15.3128 14.8238 15.3128 14.7499C15.3128 14.676 15.2982 14.6028 15.2699 14.5345C15.2417 14.4663 15.2002 14.4042 15.1479 14.3519ZM1.81248 6.87492C1.81248 5.87365 2.10939 4.89487 2.66566 4.06234C3.22194 3.22982 4.01259 2.58094 4.93764 2.19778C5.86269 1.81461 6.88059 1.71435 7.86262 1.90969C8.84465 2.10503 9.7467 2.58718 10.4547 3.29519C11.1627 4.00319 11.6449 4.90524 11.8402 5.88727C12.0355 6.8693 11.9353 7.8872 11.5521 8.81225C11.169 9.7373 10.5201 10.528 9.68755 11.0842C8.85503 11.6405 7.87625 11.9374 6.87498 11.9374C5.53278 11.9359 4.24597 11.4021 3.29689 10.453C2.34781 9.50392 1.81397 8.21712 1.81248 6.87492Z" fill="#DAD9D9" />
                      </svg>
                    )}
                  </div>
                )}
                <a className="setting-icon" onClick={() => setEnableSetting(!enablesetting)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M12.8335 15.5833H4.5835" stroke="#DAD9D9" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17.4165 6.41669H9.1665" stroke="#DAD9D9" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M15.5835 18.3333C17.1023 18.3333 18.3335 17.1021 18.3335 15.5833C18.3335 14.0645 17.1023 12.8333 15.5835 12.8333C14.0647 12.8333 12.8335 14.0645 12.8335 15.5833C12.8335 17.1021 14.0647 18.3333 15.5835 18.3333Z" stroke="#DAD9D9" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.4165 9.16669C7.93529 9.16669 9.1665 7.93547 9.1665 6.41669C9.1665 4.8979 7.93529 3.66669 6.4165 3.66669C4.89772 3.66669 3.6665 4.8979 3.6665 6.41669C3.6665 7.93547 4.89772 9.16669 6.4165 9.16669Z" stroke="#DAD9D9" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </div>
              <span className="border-line"></span>
              <div className="right-option-list-parent">
                {
                  theme === 'dark' ? <img src="\assets\banner\optionlistshade.png" alt="img" className="img-fluid optionlistshade" style={showNext ? { opacity: "1" } : { opacity: "0" }} /> :
                    <img src="\assets\banner\optionlistshadelight.png" alt="img" className="img-fluid optionlistshade" style={showNext ? { opacity: "1" } : { opacity: "0" }} />
                }
                {
                  theme === 'dark' ? <img src="\assets\banner\optionlistshadeleft.png" alt="img" className="img-fluid optionlistshadeleft" style={showPrev ? { opacity: "1" } : { opacity: "0" }} /> :
                    <img src="\assets\banner\optionlistshadeleftlight.png" alt="img" className="img-fluid optionlistshadeleft" style={showPrev ? { opacity: "1" } : { opacity: "0" }} />
                }
                <div className="right-option-list" ref={scrollRef}>
                  <div className="options-scroller">
                    {tabProperties?.map((tab) => (
                      <a onClick={() => setKey(tab?.eventKey)} className={key === tab.eventKey ? "active" : ""}>{tab?.title}</a>
                    ))}
                  </div>

                </div>
                {
                  showPrev && (
                    <div className="prev-btn" onClick={handlePrev}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M2.95109 11.4868L9.13859 17.6743C9.2676 17.8033 9.44256 17.8758 9.625 17.8758C9.80744 17.8758 9.9824 17.8033 10.1114 17.6743C10.2404 17.5453 10.3129 17.3703 10.3129 17.1879C10.3129 17.0054 10.2404 16.8305 10.1114 16.7015L5.09695 11.6879L18.5625 11.6879C18.7448 11.6879 18.9197 11.6155 19.0486 11.4865C19.1776 11.3576 19.25 11.1827 19.25 11.0004C19.25 10.818 19.1776 10.6432 19.0486 10.5142C18.9197 10.3853 18.7448 10.3129 18.5625 10.3129L5.09695 10.3129L10.1114 5.29929C10.2404 5.17029 10.3129 4.99532 10.3129 4.81288C10.3129 4.63044 10.2404 4.45548 10.1114 4.32648C9.9824 4.19747 9.80744 4.125 9.625 4.125C9.44256 4.125 9.2676 4.19747 9.13859 4.32648L2.95109 10.514C2.88717 10.5778 2.83646 10.6537 2.80186 10.7371C2.76727 10.8206 2.74946 10.91 2.74946 11.0004C2.74946 11.0907 2.76727 11.1802 2.80186 11.2637C2.83646 11.3471 2.88717 11.4229 2.95109 11.4868Z" fill="#DAD9D9" />
                      </svg>
                    </div>
                  )
                }
                {
                  showNext && (
                    <div className="next-btn" onClick={handleNext}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M19.0489 11.4868L12.8614 17.6743C12.7324 17.8033 12.5574 17.8758 12.375 17.8758C12.1926 17.8758 12.0176 17.8033 11.8886 17.6743C11.7596 17.5453 11.6871 17.3703 11.6871 17.1879C11.6871 17.0054 11.7596 16.8305 11.8886 16.7015L16.903 11.6879L3.4375 11.6879C3.25516 11.6879 3.0803 11.6155 2.95136 11.4865C2.82243 11.3576 2.75 11.1827 2.75 11.0004C2.75 10.818 2.82243 10.6432 2.95136 10.5142C3.0803 10.3853 3.25516 10.3129 3.4375 10.3129L16.903 10.3129L11.8886 5.29929C11.7596 5.17029 11.6871 4.99532 11.6871 4.81288C11.6871 4.63044 11.7596 4.45548 11.8886 4.32648C12.0176 4.19747 12.1926 4.125 12.375 4.125C12.5574 4.125 12.7324 4.19747 12.8614 4.32648L19.0489 10.514C19.1128 10.5778 19.1635 10.6537 19.1981 10.7371C19.2327 10.8206 19.2505 10.91 19.2505 11.0004C19.2505 11.0907 19.2327 11.1802 19.1981 11.2637C19.1635 11.3471 19.1128 11.4229 19.0489 11.4868Z" fill="#DAD9D9" />
                      </svg>
                    </div>
                  )
                }


              </div>
            </div>
            {
              enablesetting && (
                <div className="right-side-filters">
                  <Dropdown
                    className={`sortdropdown ${isOpen ? "open" : ""}`}
                    align="end"
                    onToggle={toggleDropdown}
                  >
                    <Dropdown.Toggle
                      id="dropdown-basic"
                      className={`dropdown-btn ${isOpen ? "active" : ""}`}
                    >
                      <p
                        style={{
                          color: "var(--heading-text)",
                          transition: "color 0.3s ease-in-out",
                        }}
                      >
                        Sort: {sortKeys[activeTab]}
                      </p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        style={{
                          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.3s ease-in-out",
                        }}
                      >
                        <path
                          d="M8.60196 15.5855L3.53946 10.523C3.43391 10.4174 3.37462 10.2743 3.37462 10.125C3.37462 9.97573 3.43391 9.83258 3.53946 9.72703C3.64501 9.62148 3.78816 9.56219 3.93743 9.56219C4.0867 9.56219 4.22985 9.62148 4.3354 9.72703L8.43743 13.8298L8.43743 2.8125C8.43743 2.66332 8.49669 2.52024 8.60218 2.41475C8.70767 2.30926 8.85075 2.25 8.99993 2.25C9.14912 2.25 9.29219 2.30926 9.39768 2.41475C9.50317 2.52024 9.56243 2.66332 9.56243 2.8125L9.56243 13.8298L13.6645 9.72703C13.77 9.62148 13.9132 9.56219 14.0624 9.56219C14.2117 9.56219 14.3549 9.62148 14.4604 9.72703C14.5659 9.83258 14.6252 9.97573 14.6252 10.125C14.6252 10.2743 14.5659 10.4174 14.4604 10.523L9.3979 15.5855C9.34566 15.6378 9.28362 15.6793 9.21533 15.7076C9.14705 15.7359 9.07385 15.7504 8.99993 15.7504C8.92601 15.7504 8.85281 15.7359 8.78453 15.7076C8.71624 15.6793 8.6542 15.6378 8.60196 15.5855Z"
                          fill="#DAD9D9"
                        />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {[t("Latest"), t("By Volume"), t("By Liquidity")].map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          className={`dropitem ${sortKeys[activeTab] === item ? "activeitem" : ""
                            }`}
                          onClick={() => handleSelectSorting(item)}
                        >
                          {item}
                          {sortKeys[activeTab] === item && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M21.5306 7.28062L9.53055 19.2806C9.4609 19.3503 9.37818 19.4057 9.28713 19.4434C9.19609 19.4812 9.09849 19.5006 8.99993 19.5006C8.90137 19.5006 8.80377 19.4812 8.71272 19.4434C8.62168 19.4057 8.53896 19.3503 8.4693 19.2806L3.2193 14.0306C3.07857 13.8899 2.99951 13.699 2.99951 13.5C2.99951 13.301 3.07857 13.1101 3.2193 12.9694C3.36003 12.8286 3.55091 12.7496 3.74993 12.7496C3.94895 12.7496 4.13982 12.8286 4.28055 12.9694L8.99993 17.6897L20.4693 6.21936C20.61 6.07863 20.8009 5.99957 20.9999 5.99957C21.199 5.99957 21.3898 6.07863 21.5306 6.21936C21.6713 6.36009 21.7503 6.55097 21.7503 6.74999C21.7503 6.94901 21.6713 7.13988 21.5306 7.28062Z"
                                fill="#E6FF00"
                              />
                            </svg>
                          )}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  <Dropdown
                    className='sortdropdown'
                    align="end"
                    onToggle={toggleMarketFilter}
                  >
                    <Dropdown.Toggle
                      id="dropdown-basic"
                      className={`dropdown-btn ${isMarketFilterOpen ? "active" : ""}`}
                    >
                      <div className="formobileset">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M16.2143 3.48258C16.1277 3.28255 15.9842 3.11238 15.8017 2.99324C15.6192 2.87411 15.4057 2.81125 15.1877 2.8125H2.81273C2.59499 2.81293 2.38206 2.87654 2.19976 2.9956C2.01746 3.11467 1.87363 3.28407 1.78572 3.48327C1.69781 3.68247 1.66959 3.9029 1.70449 4.11782C1.73939 4.33274 1.83591 4.53292 1.98233 4.69407L1.98796 4.70039L6.75023 9.78539V15.1875C6.75018 15.3911 6.80539 15.5909 6.90997 15.7656C7.01455 15.9403 7.16459 16.0834 7.34408 16.1795C7.52356 16.2756 7.72577 16.3212 7.92915 16.3115C8.13252 16.3017 8.32944 16.2369 8.4989 16.1241L10.7489 14.6236C10.9031 14.5209 11.0296 14.3816 11.1171 14.2182C11.2045 14.0548 11.2503 13.8724 11.2502 13.687V9.78539L16.0132 4.70039L16.0188 4.69407C16.1668 4.53366 16.2642 4.33321 16.299 4.11776C16.3338 3.90231 16.3043 3.68139 16.2143 3.48258ZM10.2785 9.18141C10.1812 9.28458 10.1265 9.42069 10.1252 9.5625V13.687L7.87522 15.1875V9.5625C7.87527 9.41967 7.82097 9.28216 7.72335 9.17789L2.81273 3.9375H15.1877L10.2785 9.18141Z" fill="#747474" />
                        </svg>
                        <p
                          style={{
                            color: "var(--heading-text)",
                            transition: "color 0.3s ease-in-out",
                          }}
                        >{selectedMarketFilter}
                        </p>
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        style={{
                          transform: isMarketFilterOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.3s ease-in-out",
                        }}
                      >
                        <path
                          d="M8.60196 15.5855L3.53946 10.523C3.43391 10.4174 3.37462 10.2743 3.37462 10.125C3.37462 9.97573 3.43391 9.83258 3.53946 9.72703C3.64501 9.62148 3.78816 9.56219 3.93743 9.56219C4.0867 9.56219 4.22985 9.62148 4.3354 9.72703L8.43743 13.8298L8.43743 2.8125C8.43743 2.66332 8.49669 2.52024 8.60218 2.41475C8.70767 2.30926 8.85075 2.25 8.99993 2.25C9.14912 2.25 9.29219 2.30926 9.39768 2.41475C9.50317 2.52024 9.56243 2.66332 9.56243 2.8125L9.56243 13.8298L13.6645 9.72703C13.77 9.62148 13.9132 9.56219 14.0624 9.56219C14.2117 9.56219 14.3549 9.62148 14.4604 9.72703C14.5659 9.83258 14.6252 9.97573 14.6252 10.125C14.6252 10.2743 14.5659 10.4174 14.4604 10.523L9.3979 15.5855C9.34566 15.6378 9.28362 15.6793 9.21533 15.7076C9.14705 15.7359 9.07385 15.7504 8.99993 15.7504C8.92601 15.7504 8.85281 15.7359 8.78453 15.7076C8.71624 15.6793 8.6542 15.6378 8.60196 15.5855Z"
                          fill="#DAD9D9"
                        />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {marketFilterOptions.map((item) => (
                        <Dropdown.Item
                          key={item}
                          className={`dropitem ${selectedMarketFilter === item ? "activeitem" : ""}`}
                          onClick={() => handleMarketFilterSelect(item)}
                        >
                          {item}
                          {selectedMarketFilter === item && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M21.5306 7.28062L9.53055 19.2806C9.4609 19.3503 9.37818 19.4057 9.28713 19.4434C9.19609 19.4812 9.09849 19.5006 8.99993 19.5006C8.90137 19.5006 8.80377 19.4812 8.71272 19.4434C8.62168 19.4057 8.53896 19.3503 8.4693 19.2806L3.2193 14.0306C3.07857 13.8899 2.99951 13.699 2.99951 13.5C2.99951 13.301 3.07857 13.1101 3.2193 12.9694C3.36003 12.8286 3.55091 12.7496 3.74993 12.7496C3.94895 12.7496 4.13982 12.8286 4.28055 12.9694L8.99993 17.6897L20.4693 6.21936C20.61 6.07863 20.8009 5.99957 20.9999 5.99957C21.199 5.99957 21.3898 6.07863 21.5306 6.21936C21.6713 6.36009 21.7503 6.55097 21.7503 6.74999C21.7503 6.94901 21.6713 7.13988 21.5306 7.28062Z"
                                fill="#E6FF00"
                              />
                            </svg>
                          )}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )
            }

            <div className="tabsmain">
              <div className={pools && pools?.length > 0 ? "inner-tab-content" : "inner-tab-content nodatafoundstyling"}>
                {isTableLoading ? (
                  <div className="pb-5 pt-5 text-center">
                    {
                      theme === 'dark' ? <img width={50} className="mt-n4" src="/loader.svg" alt="img" /> :
                        <img width={50} className="mt-n4 loader_rotate" src="/loaderlight.svg" alt="img" />
                    }
                  </div>
                ) : (
                  pools && pools.length > 0 ? (
                    pools.map((pool, index) => {
                      const volumeDecimal = convertFromWeiEthers(pool.totalVolume, pool?.token?.tokenDecimals);

                      return (
                        <a href={detailPath(pool._id)} className="inner-row" key={index}>
                          <div className="upper-area">
                            <p>
                              {!isStableTokenSymbol(pool?.token?.tokenSymbol) && <span className="incentiv-bg"><span className="incetiv-tag">Altcoin</span></span>} {" "}
                              {pool?.tags?.length > 0 ? (
                                <>
                                  {pool.tags.slice(0, 2).join(", ")}
                                  {pool.tags.length > 2 && ` +${pool.tags.length - 2} More`}
                                </>
                              ) : (
                                t("")
                              )}
                            </p>
                            <span className="livetext" style={{ backgroundColor: MARKET_STATUS_BACKGROUNDS[pool.status], color: MARKET_STATUS_TEXT_COLORS[pool.status], }}>{t(MARKET_STATUS[pool.status])}</span>
                          </div>
                          <h4 className="question-text">{pool.question}</h4>
                          <div className="mid-options">
                            {renderOptions(
                              pool.options,
                              2,
                              false,
                              theme
                            )}
                          </div>
                          <div className="bottom-inline">
                            <div className="single-inline">
                              <p>{t('Volume')}</p>
                              <h6>${volumeDecimal ? formatNumberWithCommas(formatSmartDecimal(isStableTokenSymbol(pool?.token?.tokenSymbol) ? +volumeDecimal : +volumeDecimal * tokenPriceToUsdt)) : "0"}</h6>
                            </div>
                            <div className="single-inline">
                              <p>{t('Trade With')}</p>
                              <h6>{getTokenSymbol(pool?.token?.tokenSymbol, true)} {getMarketToken(pool?.token).label} </h6>
                            </div>
                            <div className="single-inline">
                              <PoolTimerUI
                                poolstart={pool?.startDate}
                                poolend={pool?.endDate}
                                poolsdetail={pool}
                                setPollStatus={setPollStatus}
                                setIsDisabled={setIsDisabled}
                                endedTextColor={theme === LIGHT_THEME ? "#212121" : "#FFFFFF"}
                              />
                            </div>
                          </div>
                        </a>
                      );
                    })
                  ) : (
                    <div className="whennopolls">
                      <svg xmlns="http://www.w3.org/2000/svg" width="113" height="112" viewBox="0 0 113 112" fill="none">
                        <path d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z" fill="#2F2F2F" />
                        <path d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z" fill="#353535" />
                        <path d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z" fill="#2F2F2F" />
                        <path d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z" fill="#3E3E3E" />
                        <path d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z" fill="#2F2F2F" />
                        <path d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z" fill="#3E3E3E" />
                        <path d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z" fill="#393939" />
                      </svg>
                      <p>{t('No Markets Found')}</p>
                    </div>
                  )
                )}

              </div>
              {!isTableLoading &&
                <CustomPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              }
            </div>
            {/* <Tabs
              defaultActiveKey="public"
              id="uncontrolled-tab-example"
              className="newparenttabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
            >
              <Tab eventKey="public" title={t("Public Markets")}>
                <div className="tabsmain">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="bannertabs"
                  >
                    {tabProperties.map((tab) => (
                      <Tab eventKey={tab.eventKey} title={tab.title} key={tab.eventKey}>
                        <div className={pools && pools?.length > 0 ? "inner-tab-content" : "inner-tab-content nodatafoundstyling"}>
                          {isTableLoading ? (
                            <div className="pb-5 pt-5 text-center">
                              {
                                theme === 'dark' ? <img width={50} className="mt-n4" src="/loader.svg" alt="img" /> :
                                  <img width={50} className="mt-n4 loader_rotate" src="/loaderlight.svg" alt="img" />
                              }
                            </div>
                          ) : (
                            pools && pools.length > 0 ? (
                              pools.map((pool, index) => {
                                const volumeDecimal = convertFromWei(pool.totalVolume, 'ether');
                                return (
                                  <a href={detailPath(pool._id)} className="inner-row" key={index}>
                                    <div className="upper-area">
                                      <p>
                                        {pool?.tags?.length > 0 ? (
                                          <>
                                            {pool.tags.slice(0, 2).join(", ")}
                                            {pool.tags.length > 2 && ` +${pool.tags.length - 2} More`}
                                          </>
                                        ) : (
                                          "No tags available"
                                        )}
                                      </p>
                                      {pool?.status === "open" && selectedMarketFilter != UPCOMING_MARKETS ? (
                                        <span className="livetext">Live</span>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <h4 className="question-text">{pool.question}</h4>
                                    <div className="mid-options">
                                      {renderOptions(
                                        pool.options,
                                        2,
                                        false,
                                        theme
                                      )}
                                    </div>
                                    <div className="bottom-inline">
                                      <div className="single-inline">
                                        <p>{t('Volume')}</p>
                                        <h6>${volumeDecimal ? formatNumbers(+volumeDecimal) : "0"}</h6>
                                      </div>
                                      <div className="single-inline">
                                        <PoolTimerUI
                                          poolstart={pool?.startDate}
                                          poolend={pool?.endDate}
                                          poolsdetail={pool}
                                          setPollStatus={setPollStatus}
                                          setIsDisabled={setIsDisabled}
                                          endedTextColor={theme === LIGHT_THEME ? "#212121" : "#FFFFFF"}
                                        />
                                      </div>
                                    </div>
                                  </a>
                                );
                              })
                            ) : (
                              <div className="whennopolls">
                                <svg xmlns="http://www.w3.org/2000/svg" width="113" height="112" viewBox="0 0 113 112" fill="none">
                                  <path d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z" fill="#2F2F2F" />
                                  <path d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z" fill="#353535" />
                                  <path d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z" fill="#2F2F2F" />
                                  <path d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z" fill="#3E3E3E" />
                                  <path d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z" fill="#2F2F2F" />
                                  <path d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z" fill="#3E3E3E" />
                                  <path d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z" fill="#393939" />
                                </svg>
                                <p>{t('No Markets Found')}</p>
                              </div>
                            )
                          )}

                        </div>
                        {!isTableLoading &&
                          <CustomPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                          />
                        }
                      </Tab>

                    ))}
                  </Tabs>
                </div>
              </Tab>
              <Tab eventKey="private" title={t("Private Markets")}>
                <div className="tabsmain">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={keyPriv}
                    onSelect={(k) => setKeyPriv(k)}
                    className="bannertabs"
                  >
                    {tabPropertiesPriv.map((tab) => (
                      <Tab eventKey={tab.eventKey} title={tab.title} key={tab.eventKey}>
                        <div className={poolsprivate && poolsprivate?.length > 0 ? "inner-tab-content" : "inner-tab-content nodatafoundstyling"}>
                          {isTableLoading ? (
                            <div className="pb-5 pt-5 text-center">
                              {
                                theme === 'dark' ? <img width={50} className="mt-n4" src="/loader.svg" alt="img" /> :
                                  <img width={50} className="mt-n4 loader_rotate" src="/loaderlight.svg" alt="img" />
                              }
                            </div>
                          ) : (
                            poolsprivate && poolsprivate.length > 0 ? (
                              poolsprivate.map((pool, index) => {
                                const volumeDecimal = convertFromWei(pool.totalVolume, 'ether');

                                return (
                                  <a href={`/privatemarket?id=${pool._id}`} className="inner-row" key={index}>
                                    <div className="upper-area">
                                      <p>
                                        {pool?.tags?.length > 0 ? (
                                          <>
                                            {pool.tags.slice(0, 2).join(", ")}
                                            {pool.tags.length > 2 && ` +${pool.tags.length - 2} More`}
                                          </>
                                        ) : (
                                          "No tags available"
                                        )}
                                      </p>
                                      {pool?.status === "open" && selectedMarketFilter != UPCOMING_MARKETS ? (
                                        <span className="livetext">Live</span>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <h4 className="question-text"> <span className="whenlockedprivate"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                      <path d="M14.4 5.78571H12.16V4.17857C12.16 3.07035 11.7217 2.00751 10.9416 1.22388C10.1614 0.440241 9.1033 0 8 0C6.8967 0 5.83859 0.440241 5.05844 1.22388C4.27828 2.00751 3.84 3.07035 3.84 4.17857V5.78571H1.6C1.17565 5.78571 0.768687 5.95504 0.468629 6.25644C0.168571 6.55783 0 6.96662 0 7.39286V16.3929C0 16.8191 0.168571 17.2279 0.468629 17.5293C0.768687 17.8307 1.17565 18 1.6 18H14.4C14.8243 18 15.2313 17.8307 15.5314 17.5293C15.8314 17.2279 16 16.8191 16 16.3929V7.39286C16 6.96662 15.8314 6.55783 15.5314 6.25644C15.2313 5.95504 14.8243 5.78571 14.4 5.78571ZM5.76 4.17857C5.76 3.58183 5.996 3.00954 6.41608 2.58758C6.83616 2.16562 7.40591 1.92857 8 1.92857C8.59408 1.92857 9.16384 2.16562 9.58392 2.58758C10.004 3.00954 10.24 3.58183 10.24 4.17857V5.78571H5.76V4.17857ZM14.08 16.0714H1.92V7.71429H14.08V16.0714ZM9.28 11.8929C9.28 12.1471 9.20493 12.3957 9.06428 12.6072C8.92363 12.8186 8.72372 12.9834 8.48983 13.0807C8.25595 13.178 7.99858 13.2035 7.75028 13.1539C7.50199 13.1043 7.27391 12.9818 7.0949 12.802C6.91589 12.6222 6.79398 12.3931 6.74459 12.1437C6.69521 11.8943 6.72055 11.6358 6.81743 11.4008C6.91431 11.1659 7.07838 10.9651 7.28887 10.8238C7.49936 10.6825 7.74684 10.6071 8 10.6071C8.33948 10.6071 8.66505 10.7426 8.9051 10.9837C9.14514 11.2248 9.28 11.5519 9.28 11.8929Z" fill="white" />
                                    </svg> {t('[PRIVATE]')}</span></h4>
                                    <div className="mid-options">
                                      {renderOptions(
                                        pool.options,
                                        2,
                                        true,
                                        theme
                                      )}
                                    </div>
                                    <div className="bottom-inline">
                                      <div className="single-inline">
                                        <p>{t('Volume')}</p>
                                        <h6>${volumeDecimal ? formatNumbers(+volumeDecimal) : "0"}</h6>
                                      </div>
                                      <div className="single-inline">
                                        <PoolTimerUI
                                          poolstart={pool?.startDate}
                                          poolend={pool?.endDate}
                                          poolsdetail={pool}
                                          setPollStatus={setPollStatus}
                                          setIsDisabled={setIsDisabled}
                                          endedTextColor={theme === LIGHT_THEME ? "#212121" : "#FFFFFF"}
                                        />
                                      </div>
                                    </div>
                                  </a>
                                );
                              })
                            ) : (
                              <div className="whennopolls">
                                <svg xmlns="http://www.w3.org/2000/svg" width="113" height="112" viewBox="0 0 113 112" fill="none">
                                  <path d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z" fill="#2F2F2F" />
                                  <path d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z" fill="#353535" />
                                  <path d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z" fill="#2F2F2F" />
                                  <path d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z" fill="#3E3E3E" />
                                  <path d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z" fill="#2F2F2F" />
                                  <path d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z" fill="#3E3E3E" />
                                  <path d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z" fill="#393939" />
                                </svg>
                                <p>{t('No Markets Found')}</p>
                              </div>
                            )
                          )}
                        </div>
                        {!isTableLoading &&
                          <CustomPagination
                            currentPage={currentPage2}
                            totalPages={totalPages2}
                            onPageChange={handlePageChange2}
                          />
                        }
                      </Tab>
                    ))}
                  </Tabs>
                </div>
              </Tab>
            </Tabs> */}
          </div>
          <div className="bottom-new-tables">
            <div className="parent-table">
              <div className="upper-heading">
                <h6>{t('Top Gainers')}</h6>

                <div className="options-links">
                  <a href="#"
                    className={selectedtimeframewinners === null ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTimeframeChangeGainers(null);
                    }}>{t('All')}</a>
                  <a href="#"
                    className={selectedtimeframewinners === "day" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTimeframeChangeGainers("day");
                    }}>{t('D')}</a>
                  <a href="#"
                    className={selectedtimeframewinners === "week" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTimeframeChangeGainers("week");
                    }}>{t('W')}</a>
                  <a href="#"
                    className={selectedtimeframewinners === "month" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTimeframeChangeGainers("month");
                    }}>{t('M')}</a>
                </div>
              </div>
              <div className="bottom-table">
                <div className="set-custom-scrollbar">
                  <div className="bottom-td">
                    {gainers.map((data, index) => {
                      const pnlFromWei = convertFromWei(data.pnl, "ether");
                      const pnlFixed = Number(pnlFromWei || 0)?.toFixed(2);
                      return (
                        <>
                          <div className="single-td" key={index}>
                            <Link className="creator_link mt-2" to={`/user-profile?id=${data?.userId}`}>
                              <div className="twice-content">
                                <img
                                  src={data?.user?.profilePic}
                                  alt="img"
                                  className="img-fluid"
                                />
                                <h6>
                                  {data?.user?.name
                                    ? data.user.name
                                    : `${data?.user?.walletAddress?.slice(0, 5)}...${data?.user?.walletAddress?.slice(-3)}`}
                                </h6>
                              </div>
                            </Link>
                            <div className="withtitle">
                              <p>{t('Markets Participated')}</p>
                              <h6>
                                {data?.poolsCount}
                              </h6>
                            </div>
                            <div className="withtitle">
                              <p>{t('PnL')}</p>
                              <h6 style={{ color: pnlFixed >= 0 ? "var(--green-text)" : "var(--logout-text)" }}>
                                {pnlFixed >= 0 ? `$${formatNumbers(+pnlFixed)}` : `$${formatNumbers(+pnlFixed)}`}
                              </h6>
                            </div>
                          </div>
                        </>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="parent-table">
              <div className="upper-heading">
                <h6>{t('Top Losers')}</h6>
                <div className="options-links">
                  <a href="#"
                    className={selectedtimeframelosers === null ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTimeframeChangeLosers(null);
                    }}>{t('All')}</a>
                  <a href="#"
                    className={selectedtimeframelosers === "day" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTimeframeChangeLosers("day");
                    }}>{t('D')}</a>
                  <a href="#"
                    className={selectedtimeframelosers === "week" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTimeframeChangeLosers("week");
                    }}>{t("W")}</a>
                  <a href="#"
                    className={selectedtimeframelosers === "month" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTimeframeChangeLosers("month");
                    }}>{t('M')}</a>
                </div>
              </div>
              <div className="bottom-table">
                <div className="set-custom-scrollbar">
                  <div className="bottom-td">
                    {losers?.slice(1)?.map((data, index) => {
                      const pnlFromWei = convertFromWei(data.pnl, "ether");
                      const pnlFixed = Number(pnlFromWei || 0)?.toFixed(2);
                      return (
                        <>
                          <div className="single-td" key={index}>
                            <Link className="creator_link mt-2" to={`/user-profile?id=${data?.userId}`}>
                              <div className="twice-content">
                                <img src={data.user.profilePic} alt="img" className="img-fluid" />
                                <h6>
                                  {data.user.name
                                    ? data.user.name
                                    : `${data.user.walletAddress?.slice(0, 5)}...${data.user.walletAddress?.slice(-3)}`
                                  }
                                </h6>
                              </div>
                            </Link>
                            <div className="withtitle">
                              <p>{t('Markets Participated')}</p>
                              <h6>
                                {data?.poolsCount}
                              </h6>
                            </div>
                            <div className="withtitle">
                              <p>{t('PnL')}</p>
                              <h6 style={{ color: pnlFixed >= 0 ? "var(--green-text)" : "var(--logout-text)" }}>
                                {pnlFixed >= 0 ? `$${formatNumbers(+pnlFixed)}` : `$${formatNumbers(+pnlFixed)}`}
                              </h6>
                            </div>

                          </div>
                        </>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
